import React from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'common/i18n/hooks';
import { ButtonReact } from 'common/components/button';
import { ButtonTheme } from 'common/components/button/constants';
import { LENGTH, SIZE, TEXT_HIGHLIGHT_THEME, TextHighlightReact } from 'common/components/text-highlight';
import { getReportUrl } from 'common/report/util';
import { useExperimentPageContext } from 'iron/apps/experiments/src/components/context';
import { NEW_EXPERIMENT_ID } from 'iron/apps/experiments/src/components/utils';
import { useExperimentsStore } from 'apps/experiments/src/store';
import styles from './index.module.styl';
export function ExperimentListPageHeader() {
  const i18n = useTranslation();
  const navigate = useNavigate();
  const {
    projectId,
    workspaceId
  } = useExperimentPageContext();
  const handleCreateExperiment = React.useCallback(() => {
    navigate(getReportUrl("experiments/".concat(NEW_EXPERIMENT_ID), {
      projectId,
      workspaceId
    }));
  }, [projectId, workspaceId, navigate]);
  const limit = useExperimentsStore(state => state.experimentsLimit);
  const count = useExperimentsStore(state => {
    var _state$experiments;
    return ((_state$experiments = state.experiments) === null || _state$experiments === void 0 ? void 0 : _state$experiments.length) || 0;
  });
  const isLimitReached = limit !== undefined && limit > -1 && count >= limit;
  return <div className={styles.container} data-sentry-component="ExperimentListPageHeader" data-sentry-source-file="index.tsx">
      <div className={styles.title}>
        {i18n.t("experiments.list.title")}
        <div className={styles.beta}>
          <TextHighlightReact theme={TEXT_HIGHLIGHT_THEME.INFORMATION} size={SIZE.LARGE} length={LENGTH.WIDE} text={i18n.t("common.beta")} data-sentry-element="TextHighlightReact" data-sentry-source-file="index.tsx" />
        </div>
      </div>
      <ButtonReact icon={"plus"} theme={ButtonTheme.Primary} onClick={handleCreateExperiment} disabled={isLimitReached} tooltip={isLimitReached ? {
      text: i18n.t("experiments.list.limit-reached", {
        limit
      })
    } : undefined} data-sentry-element="ButtonReact" data-sentry-source-file="index.tsx">
        {i18n.t("experiments.list.new")}
      </ButtonReact>
    </div>;
}